import axios from "axios";

// TODO 로젠 API
export const LogenInstance = axios.create({
  baseURL: `${process.env.REACT_APP_LOGEN_API_URL}/AndyLogen`,
});

LogenInstance.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return response.data;
    }
  },

  (error) => {
    console.log(error);
  },
);

// TODO 로젠 API
export const LogenTestInstance = axios.create({
  baseURL: `${process.env.REACT_APP_TEST_API_URL}/AndyLogen`,
});

LogenTestInstance.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return response.data;
    }
  },

  (error) => {
    console.log(error);
  },
);

// TODO 롯데 API
export const LotteInstance = axios.create({
  baseURL: `${process.env.REACT_APP_LOTTE_API_URL}/AndyLotte`,
});

LotteInstance.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return response.data;
    }
  },

  (error) => {
    console.log(error);
  },
);

// TODO 한진 API
export const HanjinInstance = axios.create({
  baseURL: `${process.env.REACT_APP_HANJIN_API_URL}/AndyHanjin`,
});

HanjinInstance.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return response.data;
    }
  },

  (error) => {
    console.log(error);
  },
);

// TODO 한덱스 API
export const HandexInstance = axios.create({
  baseURL: `${process.env.REACT_APP_HANDEX_API_URL}/AndyHandex`,
});

HandexInstance.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return response.data;
    }
  },

  (error) => {
    console.log(error);
  },
);

// TODO 동영상 전용 API
export const videoInstance = axios.create({
  baseURL: `${process.env.REACT_APP_VIDEO_API_URL}`,
});

videoInstance.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return response.data;
    }
  },

  (error) => {
    console.log(error);
  },
);
